import React from 'react'
import MaterialSymbol from '../material-symbol'

const ArrowRightAlt = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="arrow_right_alt" {...props} />
))

ArrowRightAlt.displayName = 'ArrowRightAlt'

export default ArrowRightAlt
